import React from 'react';
import IFlightRangeData from '../../types/FlightRanges';
import FlightRangeHistoryRow from './FlightRangeHistoryRow';

interface FlightRangeHistoryTableProps {
  data: IFlightRangeData[];
  isLoading: boolean;
}

/**
 * History table component with high cohesion
 * Handles table structure and accessibility features
 */
const FlightRangeHistoryTable: React.FC<FlightRangeHistoryTableProps> = ({ 
  data, 
  isLoading 
}) => {
  if (isLoading) {
    return (
      <div 
        className="history-table__loading"
        role="status"
        aria-live="polite"
        aria-label="Loading flight range history"
      >
        <div className="loading-spinner" aria-hidden="true"></div>
        <span>Loading history...</span>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div 
        className="history-table__empty"
        role="status"
        aria-live="polite"
      >
        <p>No flight range history found.</p>
      </div>
    );
  }

  return (
    <div className="history-table__wrapper">
      <table 
        className="history-table" 
        role="grid" 
        aria-label="Flight Range History"
        aria-rowcount={data.length + 1} // +1 for header
      >
        <thead>
          <tr role="row">
            <th scope="col" aria-sort="none">JOB #</th>
            <th scope="col" aria-sort="none">MKT. CARRIER</th>
            <th scope="col" aria-sort="none">FLIGHT RANGE</th>
            <th scope="col" aria-sort="none">OP. CARRIER</th>
            <th scope="col" aria-sort="none">FLIGHT TYPE</th>
            <th scope="col" aria-sort="none">EFFECTIVE</th>
            <th scope="col" aria-sort="none">DISCONTINUED</th>
            <th scope="col" aria-sort="descending" title="Sorted by modification date, newest first">
              MODIFIED
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((range, index) => (
            <FlightRangeHistoryRow 
              key={`${range.id}-${range.modDate}`} 
              range={range}
              aria-rowindex={index + 2} // +2 because header is row 1
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FlightRangeHistoryTable;